<script setup lang="ts">
import { ChevronDownIcon, ChevronUpIcon, UnfoldMoreHorizontalIcon } from 'mdi-vue3'
import type { HTMLAttributes } from 'vue'

import { type TableSortOption } from '.'

type TableSortIconProperties = {
  class?: HTMLAttributes['class']
  direction?: TableSortOption
}

const properties = withDefaults(defineProps<TableSortIconProperties>(), {
  class: undefined,
  direction: undefined,
})
</script>

<template>
  <UnfoldMoreHorizontalIcon v-if="properties.direction === undefined" :class="['atabix-table-sort-icon', properties.class]" />
  <ChevronUpIcon v-if="properties.direction === 'asc'" :class="['atabix-table-sort-icon', properties.class]" />
  <ChevronDownIcon v-if="properties.direction === 'desc'" :class="['atabix-table-sort-icon', properties.class]" />
</template>

<style lang="scss">
.atabix-table-sort-icon {
  @apply inline-block size-4 select-none;
}
</style>
